"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Highlight = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Highlight = styled_components_1.default.object `
	pointer-events: none;

	animation: fadeIn alternate infinite;
	animation-duration: 6000ms;
	/* mix-blend-mode: multiply; */
`;
